(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
/* ── Accordion ── */
document.querySelectorAll('#ProductSection-{{ section.id }} .ep-accordion-trigger').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var body = this.nextElementSibling;
    var icon = this.querySelector('.ep-accordion-icon');
    var open = body.classList.contains('is-open');
    body.classList.toggle('is-open', !open);
    this.setAttribute('aria-expanded', !open);
    if (icon) icon.style.transform = open ? '' : 'rotate(180deg)';
  });
});

/* ── Fake viewer randomiser ── */
document.querySelectorAll('#ProductSection-{{ section.id }} .js-fake-view').forEach(function(el) {
  var min = parseInt(el.dataset.min, 10) || 12;
  var max = parseInt(el.dataset.max, 10) || 30;
  var dur = (parseInt(el.dataset.duration, 10) || 3) * 1000;
  var num = el.querySelector('.js-fake-num');
  if (!num) return;
  setInterval(function() {
    num.textContent = Math.floor(Math.random() * (max - min + 1)) + min;
  }, dur);
});

/* ── Countdown timer ── */
document.querySelectorAll('#ProductSection-{{ section.id }} .js-countdown-grid').forEach(function(grid) {
  var end = new Date(grid.dataset.end.replace(/\//g, '-')).getTime();
  var hEl = grid.querySelector('.js-cd-hours');
  var mEl = grid.querySelector('.js-cd-mins');
  var sEl = grid.querySelector('.js-cd-secs');
  function pad(n) { return n < 10 ? '0' + n : n; }
  function tick() {
    var diff = end - Date.now();
    if (diff <= 0) { grid.closest('.ep-countdown-row').style.display = 'none'; return; }
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  tick(); setInterval(tick, 1000);
});

/* ── PhotoSwipe ── */
var initPhotoSwipeFromDOM = function(gallerySelector) {
  var parseThumbs = function() {
    return Array.prototype.slice.call(document.querySelectorAll('.photo-image')).map(function(fig) {
      var link = fig.children[0];
      var size = (link.getAttribute('data-size') || '').split('x');
      var item = { src: link.getAttribute('href'), w: parseInt(size[0], 10) || 0, h: parseInt(size[1], 10) || 0, el: fig };
      if (fig.children.length > 1) item.title = fig.children[1].innerHTML;
      if (link.children.length > 0) item.msrc = link.children[0].getAttribute('src');
      return item;
    });
  };
  var closest = function(el, fn) { return el && (fn(el) ? el : closest(el.parentNode, fn)); };
  var openPS = function(index, gallery, noAnim, fromURL) {
    var pswp = document.querySelectorAll('.pswp')[0];
    var opts = { maxSpreadZoom:1, bgOpacity:0.88, zoomEl:true, history:false, pinchToClose:false, closeOnScroll:false, galleryUID: gallery.getAttribute('data-pswp-uid') };
    opts.index = fromURL ? parseInt(index, 10) - 1 : parseInt(index, 10);
    if (isNaN(opts.index)) return;
    if (noAnim) opts.showAnimationDuration = 0;
    new PhotoSwipe(pswp, PhotoSwipeUI_Default, parseThumbs(), opts).init();
  };
  var galleries = document.querySelectorAll(gallerySelector);
  for (var i = 0; i < galleries.length; i++) {
    galleries[i].setAttribute('data-pswp-uid', i + 1);
    galleries[i].onclick = function(e) {
      e = e || window.event; e.preventDefault ? e.preventDefault() : (e.returnValue = false);
      var item = closest(e.target || e.srcElement, function(el) { return el.tagName && el.tagName.toUpperCase() === 'FIGURE'; });
      if (!item) return;
      var nodes = item.parentNode.childNodes, idx = 0, found;
      for (var j = 0; j < nodes.length; j++) { if (nodes[j].nodeType !== 1) continue; if (nodes[j] === item) { found = idx; break; } idx++; }
      if (found >= 0) openPS(found, item.parentNode);
      return false;
    };
  }
  var hash = (function() {
    var h = window.location.hash.substring(1), p = {};
    if (h.length < 5) return p;
    h.split('&').forEach(function(v) { var pair = v.split('='); if (pair.length >= 2) p[pair[0]] = pair[1]; });
    if (p.gid) p.gid = parseInt(p.gid, 10);
    return p;
  })();
  if (hash.pid && hash.gid) openPS(hash.pid, galleries[hash.gid - 1], true, true);
};
initPhotoSwipeFromDOM('.my-gallery');


/* ── Wooter-style modal controls ── */
document.querySelectorAll('.js-wooter-modal-open').forEach(function(btn){
  btn.addEventListener('click', function(){
    var modal = document.getElementById(this.getAttribute('data-modal-target'));
    if (modal) modal.classList.add('is-open');
  });
});
document.querySelectorAll('.js-wooter-modal-close, .ep-wooter-modal__overlay').forEach(function(el){
  el.addEventListener('click', function(){
    var modal = this.closest('.ep-wooter-modal');
    if (modal) modal.classList.remove('is-open');
  });
});
document.addEventListener('keydown', function(e){
  if (e.key === 'Escape') {
    document.querySelectorAll('.ep-wooter-modal.is-open').forEach(function(modal){
      modal.classList.remove('is-open');
    });
  }
});


  } catch(e) { console.error(e); }
})();
})();
